import React from 'react';

import { AlertDialogModal } from 'clipsal-cortex-ui/src/components/AlertDialogModal';

import { useMostRecentTariff } from '../../bills/tariffs/tariffApi';

export type UpdateTariffAlertDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * This alert dialog will be shown when the user has no tariffs set up in the app but wants to use SmartSave.
 * And since it is used in multiple places, it is extracted to a separate component.
 * This is to avoid code duplication and to make it easier to maintain.
 */
export const UpdateTariffAlertDialog = ({ isOpen, onClose, onConfirm, onCancel }: UpdateTariffAlertDialogProps) => {
  const { isTariffOlderThanAYear, isLoading: isTariffsDataLoading } = useMostRecentTariff();

  return (
    <AlertDialogModal
      header={isTariffOlderThanAYear ? 'Update your tariff!' : 'No tariff found!'}
      subHeader={
        isTariffOlderThanAYear
          ? 'Your tariff is older than a year. Please update it to get the best out of SmartSave. Would you like to add a new tariff?'
          : 'Without a tariff, SmartSave will not be able to properly optimise your devices. Would you like to add a tariff now?'
      }
      dialogContentTestId={`${isTariffOlderThanAYear ? 'update' : 'add'}-tariff-alert-dialog`}
      isOpen={isOpen}
      onClose={onClose}
      onCancel={onCancel}
      onConfirm={onConfirm}
      confirmButtonName={isTariffOlderThanAYear ? 'Add new tariff' : 'Set up my tariff'}
      cancelButtonName="Skip for now"
      cancelButtonTextColor="gray.500"
      confirmButtonTextColor="primaryBrandingStatic.500"
      confirmButtonProps={{
        fontWeight: 'normal',
        isDisabled: isTariffsDataLoading,
      }}
      cancelButtonProps={{
        isDisabled: isTariffsDataLoading,
      }}
    />
  );
};
